import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AuthModalComponent } from './auth-modal/auth-modal.component';
import {
  LoginStrategyComponent,
  ResetPasswordStrategyComponent,
  SignupStrategyComponent,
} from './auth-modal/components';
import { DialogComponent } from '@shared/components';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AuthModalComponent,
    LoginStrategyComponent,
    SignupStrategyComponent,
    ResetPasswordStrategyComponent,
    DialogComponent,
  ],
  exports: [AuthModalComponent],
})
export class AuthModule {}
